import { useCallback, useEffect, useState } from 'react';
import { Accordion, AccordionHeader, AccordionItem, AccordionPanel, AccordionToggleEventHandler, Title3 } from '@fluentui/react-components';

import {
    FolderRegular,
    EditRegular,
    OpenRegular,
    DocumentRegular,
    PeopleRegular,
    DocumentPdfRegular,
    VideoRegular,
} from "@fluentui/react-icons";
import {
    TableBody,
    TableCell,
    TableRow,
    Table,
    TableHeader,
    TableHeaderCell,
    TableCellLayout,
    PresenceBadgeStatus,
    Avatar,
} from "@fluentui/react-components";

import useFetch from '../Hooks/useFetchAPI';
import { useSignInState } from './signInState';

const LicenseDetails = () => {
    const { signInState } = useSignInState();
    const { fetchAPI: fetchLicenses, apiData: licenseData, isLoading: isLoadingLicenses, serverError: serverErrorLicenses } = useFetch({ scope: 'AdminUser' })

    const [licenseInfo, setlicenseInfo] = useState<LicenseDataResult[] | null>(null);

    useEffect(() => {
        const fetchLicensesAsync = async () => {
            await fetchLicenses({ url: 'admin/getlicenses', method: 'GET' });
        };

        fetchLicensesAsync()
    }, [signInState.currentCustomerID]);

    useEffect(() => {
        if (!isLoadingLicenses && !serverErrorLicenses && licenseData) {
            let licenseDataResults: LicenseDataResult[] | null = null;
            if (licenseData && (licenseData as unknown as { result: LicenseDataResult[] }).result) {
                licenseDataResults = (licenseData as unknown as { result: LicenseDataResult[] }).result;
                console.log(licenseDataResults);
                setlicenseInfo(licenseDataResults)
            }
        }
    }, [isLoadingLicenses, serverErrorLicenses, licenseData]);

    useEffect(() => {
        console.log('licenseInfo:', licenseInfo);
    }, [licenseInfo]);

    return (
            <div style={{ marginLeft: '20px' }}>
                <Table arial-label="Licensing information" style={{ minWidth: "510px", maxWidth: "1300px" }}>
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell key="License Name">
                                License Name
                            </TableHeaderCell>
                            <TableHeaderCell key="Start Date">
                                Start Date
                            </TableHeaderCell>
                            <TableHeaderCell key="Expiry Date">
                                Expiry Date
                            </TableHeaderCell>
                            <TableHeaderCell key="License Type">
                                License Type
                            </TableHeaderCell>
                            <TableHeaderCell key="Status">
                                Status
                            </TableHeaderCell>
                            <TableHeaderCell key="Modules">
                                Modules
                            </TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {licenseInfo?.map((license, index) => (
                            <TableRow key={index}>
                                <TableCell>{license.DisplayName}</TableCell>
                                <TableCell>{new Date(license.StartDate).toLocaleDateString(undefined, { day: '2-digit', month: '2-digit', year: 'numeric' })}</TableCell>
                                <TableCell>{new Date(license.ExpiryDate).toLocaleDateString(undefined, { day: '2-digit', month: '2-digit', year: 'numeric' })}</TableCell>
                                <TableCell>{license.Type}</TableCell>
                                <TableCell>{license.IsActive ? 'Active' : 'Disabled'}</TableCell>
                                <TableCell><ul>
                                    {license.modules.map((module, index) => (
                                        <li key={index}>{module.DisplayName}</li>
                                    ))}
                                </ul></TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
    );
}

export default LicenseDetails;